__turbopack_context__.v({
  "closeButton": "ConfirmDialog-module__6my7vG__closeButton",
  "confirmationMessage": "ConfirmDialog-module__6my7vG__confirmationMessage",
  "dialogControls": "ConfirmDialog-module__6my7vG__dialogControls",
  "errorButton": "ConfirmDialog-module__6my7vG__errorButton",
  "formContentWrapper": "ConfirmDialog-module__6my7vG__formContentWrapper",
  "modal": "ConfirmDialog-module__6my7vG__modal",
  "modalContent": "ConfirmDialog-module__6my7vG__modalContent",
  "primaryButton": "ConfirmDialog-module__6my7vG__primaryButton",
  "secondaryButton": "ConfirmDialog-module__6my7vG__secondaryButton",
  "toggleButton": "ConfirmDialog-module__6my7vG__toggleButton",
});
